import initialState from './initialState';
import { reducer as createScheduleReducer } from './createSchedule';
import { reducer as listScheduleReducer } from './listSchedule';
import { reducer as updateScheduleReducer } from './updateSchedule';
import { reducer as deleteScheduleReducer } from './deleteSchedule';
import { reducer as loadTaskDetailReducer } from './loadTaskDetail';
import { reducer as loadEmailTemplatesReducer } from './loadEmailTemplates';
import { reducer as loadCollectionInScheduleReducer } from './loadCollectionInSchedule';
import { reducer as loadExternalApisInScheduleReducer } from './loadExternalApisInSchedule';
import { reducer as changeTaskDetailReducer } from './changeTaskDetail';
import { reducer as resumeScheduleReducer } from './resumeSchedule';
import { reducer as pauseScheduleReducer } from './pauseSchedule';
import { reducer as getPermissionFlagsReducer } from './getPermissionFlags';

const reducers = [createScheduleReducer, listScheduleReducer, updateScheduleReducer, deleteScheduleReducer, loadTaskDetailReducer, loadEmailTemplatesReducer, loadCollectionInScheduleReducer, loadExternalApisInScheduleReducer, changeTaskDetailReducer, resumeScheduleReducer, pauseScheduleReducer, getPermissionFlagsReducer];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
